<div class="dashboard-queries">
    <div class="dashboard-queries-header">
        <label>The grid below displays all the queries available in this dashboard.</label>
        <p-button styleClass="p-button-outlined"
                  label="Local query"
                  icon="pi pi-plus"
                  [disabled]="!dashboardId"
                  (onClick)="onQueryCreate()"></p-button>
    </div>
    <grid [tableSettings]="tableSettings"
          [gridSettings]="gridSettings">
        <ng-template gridColumnTemplate="displayingRow" columnName="widgets" let-rowData>
            <div class="formatted-cell" [innerHTML]="getQueryUsagesFormattedString(rowData.widgets)"></div>
        </ng-template>
    </grid>
</div>

<p-dialog [(visible)]="displayQueryBuilder"
          [header]="editQueryDialogHeader"
          [modal]="true"
          [maximizable]="true"
          [resizable]="true"
          [draggable]="true"
          (onHide)="onQueryBuilderClose()"
          styleClass="dashboard-query-builder-dialog">
    <ng-template pTemplate="content">
        <query-builder [querySourceId]="dashboardQueryEditing?.querySourceId"
                       [queryAccessLevel]="QueryAccessLevel.Restricted"
                       [standalone]="true"></query-builder>
    </ng-template>
    <p-footer>
        <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-secondary"
                  (onClick)="onQueryBuilderCancel()"></p-button>
        <p-button label="Update Preview (Ctrl + Enter)" icon="pi pi-eye"
                  (onClick)="onQueryBuilderUpdatePreview()"></p-button>
        <p-button label="Save" icon="pi pi-check"
                  (onClick)="onQueryBuilderSave()"
                  [disabled]="queryBuilderDisabled"></p-button>
    </p-footer>
</p-dialog>